<template>
    <div>
        <!-- Info Banner -->
        <div class="form-info-banner">
            <h3 class="form-info-banner-title">Os campos com * são de preenchimento obrigatório</h3>
            <p class="form-info-banner-text">Caso queira, você poderá salvar e continuar depois.</p>
        </div>
        
        <!-- Seção: Endereço da Sede -->
        <section class="form-section">
            <div class="form-section-header">
                <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Endereço da Sede'"
                    :TipoCliente="'Pessoa Jurídica'" :Sessao="'Endereço'" :SubSessao="'Endereço'" />
            </div>
            <div class="form-section-content">
                <div class="form-subsection">
                    <h4 class="form-subsection-title">
                        <i class="fa fa-map-marker"></i>
                        Localização
                    </h4>
                    <div class="form-grid-12">
                        <div class="col-span-3 form-field">
                            <div class="flex items-center justify-between">
                                <label class="form-field-label form-field-label-required" for="cep">CEP</label>
                                <a target="_blank" class="form-link text-xs"
                                    href="https://buscacepinter.correios.com.br/app/endereco/index.php">Não sei o CEP</a>
                            </div>
                            <input class="field" type="text" id="cep" placeholder="" v-model="localPJ.Cep"
                                @change="validarCep(localPJ)">
                            <p v-if="camposObrigatorios.erroCep" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="col-span-7 form-field">
                            <label class="form-field-label form-field-label-required" for="endereco">Endereço/Logradouro</label>
                            <input class="field" type="text" :disabled="isDisabledEnderecoLogradouro" id="endereco"
                                v-model="localPJ.Logradouro" placeholder="" @change="salvarAlteracoesLocalmente">
                            <p v-if="camposObrigatorios.erroLogradouro" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="col-span-2 form-field">
                            <label class="form-field-label form-field-label-required" for="logradouroNumero">Número</label>
                            <input class="field" type="text" id="logradouroNumero" @change="salvarAlteracoesLocalmente"
                                v-model="localPJ.LogradouroNumero" placeholder="">
                            <p v-if="camposObrigatorios.erroNumero" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                    <div class="form-grid-3">
                        <div class="form-field">
                            <label class="form-field-label" for="complemento">Complemento</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmente"
                                v-model="localPJ.LogradouroComplemento" id="complemento" placeholder="">
                        </div>
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="bairro">Bairro</label>
                            <input class="field" type="text" :disabled="isDisabledEnderecoLogradouro" v-model="localPJ.Bairro"
                                id="bairro" placeholder="" @change="salvarAlteracoesLocalmente">
                            <p v-if="camposObrigatorios.erroBairro" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                    <div class="form-grid-3">
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="cidade">Cidade</label>
                            <input class="field" type="text" :disabled="isDisabledEndereco" v-model="localPJ.Cidade"
                                id="cidade" placeholder="" @change="salvarAlteracoesLocalmente">
                            <p v-if="camposObrigatorios.erroCidade" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="uf">UF</label>
                            <select class="field" :disabled="isDisabledEndereco" id="uf" v-model="localPJ.Uf" @change="salvarAlteracoesLocalmente">
                                <option value="null">Selecione</option>
                                <option v-for="uf in ufs" :key="uf" :value="uf">
                                    {{ uf }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroUf" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="Pais">País</label>
                            <select id="Pais" @change="salvarAlteracoesLocalmente" class="field"
                                v-model="localPJ.Pais" :disabled="isDisabledEndereco" >
                                <option value="">Selecione</option>
                                <option v-for="item in listaPaises" :key="item.Codigo" :value="item.Codigo">
                                    {{ item.Descricao }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroPais" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <ModalAlerta v-if="modalAlerta.mostrar" :mostrar="modalAlerta.mostrar" :tipo="modalAlerta.tipo" :titulo="modalAlerta.titulo" :mensagem="modalAlerta.mensagem" @fechar="modalAlerta.mostrar = false" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LabelDisclaimer from '@/components/LabelDisclaimer.vue'
import { validarCampoCep, ufs } from '@/utils/formUtils';
import ModalAlerta from '../Utilitarios/ModalAlerta.vue';
export default {
    name: 'CadastroPJ_Endereco',
    props: ['informacoesEndereco', 'Edicao'],
    components: { LabelDisclaimer, ModalAlerta },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            etapaCadastro: 'GET_ETAPA_CADASTRO',
            listaPaises: 'GET_LISTA_PAISES',
        }),
        ufs() {
            return ufs;
        },
    },
    data() {
        return {
            modalAlerta: {
                mostrar: false,
                tipo: 'warning',
                titulo: '',
                mensagem: ''
            },
            camposObrigatorios: {
                erroCep: false,
                erroLogradouro: false,
                erroNumero: false,
                erroBairro: false,
                erroCidade: false,
                erroUf: false,
                erroPais: false
            },
            isDisabledEndereco: true,
            isDisabledEnderecoLogradouro: true,
            permitirAvancar: false,
            localPJ: this.informacoesEndereco
        }
    },
    mounted() {
        this.validarFormulario();
    },
    methods: {
        validarFormulario(submeter) {
            this.permitirAvancar = true;
            var nomeDoCampo = '';
            this.camposObrigatorios = {
                erroCep: false,
                erroLogradouro: false,
                erroNumero: false,
                erroBairro: false,
                erroCidade: false,
                erroUf: false,
                erroPais: false
            };
            if (!this.localPJ.Cep) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroCep = true;
                    nomeDoCampo = 'CEP';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPJ.Logradouro && this.isDisabledEnderecoLogradouro === false) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroLogradouro = true;
                    nomeDoCampo = 'Endereço/Logradouro';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPJ.LogradouroNumero) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroNumero = true;
                    nomeDoCampo = 'Número do Endereço';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPJ.Bairro && this.isDisabledEnderecoLogradouro === false) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroBairro = true;
                    nomeDoCampo = 'Bairro';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPJ.Cidade && this.isDisabledEnderecoLogradouro === false) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroCidade = true;
                    nomeDoCampo = 'Cidade';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPJ.Uf && this.isDisabledEnderecoLogradouro === false) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroUf = true;
                    nomeDoCampo = 'UF';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPJ.Pais && this.isDisabledEnderecoLogradouro === false) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroPais = true;
                    nomeDoCampo = 'País';
                }
                this.permitirAvancar = false;
            }
            if (submeter && nomeDoCampo != '') {
                this.modalAlerta = {
                    mostrar: true,
                    tipo: 'warning',
                    titulo: 'Atenção: Campo obrigatório',
                    mensagem: `O campo ${nomeDoCampo} não foi informado, preencha a informação para avançar.`
                };
            }
            return this.permitirAvancar;
        },
        proximaEtapa() {
            if (this.validarFormulario(true)) {
                this.$store.commit('SET_ETAPA_CADASTRO', 6);
                this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
                this.salvarInformacoes();
            }
        },
        salvarInformacoes() {
            this.$store.commit('SET_PJ_SALVAR_INFO', true);
        },
        salvarAlteracoesLocalmente() {
            this.$store.commit('SET_PJ_SALVAR_INFO_ENDERECO', this.localPJ);
            this.validarFormulario();
        },
        async validarCep(objDados) {
            var result = await validarCampoCep(objDados);
            this.localPJ.LogradouroNumero = '';
            if (result) {
                this.isDisabledEndereco = true;
                this.isDisabledEnderecoLogradouro = true;
                if (objDados.Logradouro == '') {
                    this.isDisabledEnderecoLogradouro = false;
                }
            } else {
                this.isDisabledEndereco = false;
                this.isDisabledEnderecoLogradouro = false;
            }
        },
    }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');
</style>